import parse from "html-react-parser";
import Layout from "../components/layout";
import Seo from "../components/seo";
import { default as NextLink } from "next/link";
import Moment from "react-moment";
import { Link, Box, Text, AspectRatio } from "@chakra-ui/react";
import {
  PostArticle,
  PostTitle,
  PostMeta,
  FeatImage,
  ArticleBody,
} from "../styles/postStyles";
import { postOptions } from "../lib/parseOptions";



const PostTemplate = ({ post, menus, author }) => {
  const featuredImage = {
    alt: post.featuredImage?.node?.alt || ``,
    src: post.featuredImage?.node?.sourceUrl,
  };
  const imgSrc = featuredImage.src;
  const metaDate = new Date(post.date).toISOString();
  const modifiedDate = new Date(post.modified).toISOString();
  const breadcrumbMeta = post.seo.breadcrumbs.map((crumb, index) => {
    const position = index + 1;
    const item = {
      "@type": "ListItem",
      position: position,
      item: {
        "@type": "WebPage",
        "@id": `https://www.idrivesocal.com${crumb.url}`,
        url: `https://www.idrivesocal.com${crumb.url}`,
        name: crumb.text,
      },
    };
    return item;
  });

  const cats = post.categories.nodes.map((cat) => {
    return cat.name;
  });
  const catMeta = cats.join();
  const schema = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "Organization",
        "@id": "https://www.idrivesocal.com/#organization",
        name: "iDriveSoCal",
        url: "https://www.idrivesocal.com/",
        sameAs: [
          "https://www.facebook.com/idrivesocal/",
          "https://www.instagram.com/idrivesocal/",
          "https://www.linkedin.com/company/idrivesocal/",
          "https://www.youtube.com/channel/UC0HZusGNEBUl3lO7AdprFdQ",
          "https://www.pinterest.com/iDriveSoCal/",
          "https://twitter.com/idrivesocal",
        ],
        logo: {
          "@type": "ImageObject",
          "@id": "https://www.idrivesocal.com/#logo",
          inLanguage: "en-US",
          url:
            "https://www.idrivesocal.com/wp-content/uploads/2019/05/iDriveSoCal.jpg",
          contentUrl:
            "https://www.idrivesocal.com/wp-content/uploads/2019/05/iDriveSoCal.jpg",
          width: 824,
          height: 606,
          caption: "iDriveSoCal",
        },
        image: { "@id": "https://www.idrivesocal.com/#logo" },
      },
      {
        "@type": "WebSite",
        "@id": "https://www.idrivesocal.com/#website",
        url: "https://www.idrivesocal.com/",
        name: "iDriveSoCal",
        description: "Automotive News &amp; Events",
        publisher: { "@id": "https://www.idrivesocal.com/#organization" },
        potentialAction: [
          {
            "@type": "SearchAction",
            target: "https://www.idrivesocal.com/?s={search_term_string}",
            "query-input": "required name=search_term_string",
          },
        ],
        inLanguage: "en-US",
      },
      {
        "@type": "ImageObject",
        "@id": `https://www.idrivesocal.com${post.uri}#primaryimage`,
        inLanguage: "en-US",
        url: imgSrc,
        contentUrl: imgSrc,
        width: 940,
        height: 627,
        caption: featuredImage?.alt,
      },
      {
        "@type": "WebPage",
        "@id": `https://www.idrivesocal.com${post.uri}#webpage`,
        url: `https://www.idrivesocal.com${post.uri}`,
        name: post.title,
        isPartOf: { "@id": "https://www.idrivesocal.com/#website" },
        primaryImageOfPage: {
          "@id": `https://www.idrivesocal.com${post.uri}#primaryimage`,
        },
        datePublished: metaDate,
        dateModified: modifiedDate,
        description: post.seo.metaDesc,
        breadcrumb: {
          "@id": `https://www.idrivesocal.com${post.uri}#breadcrumb`,
        },
        inLanguage: "en-US",
        potentialAction: [
          {
            "@type": "ReadAction",
            target: [`https://www.idrivesocal.com${post.uri}`],
          },
        ],
      },
      {
        "@type": "BreadcrumbList",
        "@id": `https://www.idrivesocal.com${post.uri}#breadcrumb`,
        itemListElement: breadcrumbMeta,
      },
      {
        "@type": ["Article", "NewsArticle"],
        "@id": `https://www.idrivesocal.com${post.uri}#article`,
        isPartOf: {
          "@id": `https://www.idrivesocal.com${post.uri}#webpage`,
        },
        author: {
          "@id":
            "https://www.idrivesocal.com/#/schema/person/3103a769d4bfc520790c66d383460d0c",
        },
        headline: post.title,
        datePublished: metaDate,
        dateModified: modifiedDate,
        mainEntityOfPage: {
          "@id": `https://www.idrivesocal.com${post.uri}#webpage`,
        },
        commentCount: 0,
        publisher: { "@id": "https://www.idrivesocal.com/#organization" },
        image: {
          "@id": `https://www.idrivesocal.com${post.uri}#primaryimage`,
        },
        keywords: post.seo.focuskw,
        articleSection: catMeta,
        inLanguage: "en-US",
        potentialAction: [
          {
            "@type": "CommentAction",
            name: "Comment",
            target: [`https://www.idrivesocal.com${post.uri}#respond`],
          },
        ],
        copyrightYear: "2021",
        copyrightHolder: { "@id": "https://www.idrivesocal.com/#organization" },
      },
      {
        "@type": "Person",
        "@id":
          "https://www.idrivesocal.com/#/schema/person/3103a769d4bfc520790c66d383460d0c",
        name: "Tom Smith",
        image: {
          "@type": "ImageObject",
          "@id": "https://www.idrivesocal.com/#personlogo",
          inLanguage: "en-US",
          url:
            "https://secure.gravatar.com/avatar/5aa5f7ce3212b1123ed6e8ae1f486164?s=96&d=mm&r=g",
          contentUrl:
            "https://secure.gravatar.com/avatar/5aa5f7ce3212b1123ed6e8ae1f486164?s=96&d=mm&r=g",
          caption: "Tom Smith",
        },
        description:
          "I grew up in a small town in northern Illinois, graduated from Columbia College Chicago, and produced TV news for network affiliates. The TV news business was fun. But not the hours or many of the stories. And, I shifted to sales. But after many years I started getting fired a lot. Turns out old-school media companies don't like painful honesty and new ideas. Luckily, Al Gore invented the internet. So, I started iDSC. And cover whatever stories I want. ;0)",
        sameAs: ["https://www.linkedin.com/in/tomsmith89/"],
      },
    ],
  };
  return (
    <Layout
      menus={menus}
      author={author}
      tagPosts={post.tags.nodes}
      postId={post.id}
      cta={post.post_cta}
    >
      <Seo
        data={post}
        title={post.title}
        description={parse(post.excerpt)}
        schemaMarkup={schema}
      />
      <PostArticle itemScope itemType="http://schema.org/Article">
        <header>
          <PostTitle as="h1" px={{ base: 4, sm: 8, md: 8 }} itemProp="headline">
            {parse(post.title)}
          </PostTitle>
          <PostMeta px={{ base: 4, sm: 8, md: 8 }}>
            <Link
              as={NextLink}
              href={post.author.node.uri}
              itemProp="url"
              color="gray.500"
            >
              <span>Posted by {post.author.node.name}</span>
            </Link>
            <span>|</span>
            <span>
              <Moment date={post.date} format="MMM DD, YYYY" />
            </span>
            {post.categories.nodes && <span>|</span>}
            {post.categories.nodes &&
              post.categories.nodes.map((cat, index, cats) => {
                return (
                  <Link
                    as={NextLink}
                    href={cat.uri}
                    itemProp="url"
                    color="gray.500"
                    key={index}
                  >
                    <span key={index}>
                      {cat.name}
                      {index < cats.length - 1 && ","}
                    </span>
                  </Link>
                );
              })}
          </PostMeta>
          {featuredImage?.src && (
            <AspectRatio ratio={16 / 9}>
              <FeatImage
                src={featuredImage.src}
                alt={featuredImage.alt}
                layout="fill"
                objectFit="cover"
              />
            </AspectRatio>
          )}
        </header>
        {!!post.content && (
          <ArticleBody p={8} itemProp="articleBody">
            {parse(post.content, postOptions)}
          </ArticleBody>
        )}
        <hr />
      </PostArticle>
      <Box
        mx="auto"
        py="4"
        display="flex"
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <Text pr="4" textTransform="uppercase">
          Share:
        </Text>{" "}
        <div className="s9-widget-wrapper"></div>
      </Box>
    </Layout>
  );
};

export default PostTemplate;
